
import BookemWidget from "@/components/BookemWidget";
import { Helmet } from 'react-helmet-async';

const Booking = () => {
  return (
    <>
      <Helmet>
        <title>Book a Dietician Consultation | Functional Foodie</title>
        <meta 
          name="description" 
          content="Book a consultation with a registered dietitian in Johannesburg. Personalised nutrition guidance, in-person or virtual — secure your spot today."
        />
        <link rel="canonical" href="https://functionalfoodie.co.za/booking" />
        <meta property="og:title" content="Book a Dietician Consultation in Johannesburg | Functional Foodie" />
        <meta property="og:description" content="Book online with a registered dietitian in Johannesburg for personalised nutrition guidance." />
        <meta property="og:url" content="https://functionalfoodie.co.za/booking" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="min-h-screen py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold text-center text-primary mb-12">Book an Appointment</h1>
          <div className="max-w-4xl mx-auto">
            <BookemWidget />
          </div>
        </div>
      </div>
    </>
  );
};

export default Booking;
